import { ReactElement, createElement } from "react";

const LOGO_BASE = "https://members-legacy.worldservicesgroup.com/files/pic/";

export function firmProfilePath(companyType: string, slug: string, firmId: number): string {
  let kind = "law-firm";
  if (companyType === "Financial Management" || companyType === "Investment Banking") {
    kind = "investment-bank";
  } else if (companyType === "Accounting") {
    kind = "accounting-firm";
  }
  return `/member/${kind}/${slug.toLowerCase()}/${firmId}`;
}

export function logoUrl(logoName: string): string {
  return `${LOGO_BASE}${logoName}`;
}

export function moreDealsLabel(companyName: string): string {
  if (companyName.toLowerCase().endsWith("s")) {
    return `MORE ${companyName}' DEALS`;
  }
  return `MORE ${companyName}'S DEALS`;
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function highlightedText(text: string, words: string): ReactElement {
  const tokens = words.trim().split(/\s+/).filter((word) => word.length > 0);
  if (tokens.length === 0 || !text) {
    return createElement("span", null, text);
  }
  const pattern = new RegExp(`(${tokens.map(escapeRegExp).join("|")})`, "ig");
  const parts = text.split(pattern);
  return createElement(
    "span",
    null,
    parts.map((part, index) => {
      const match = tokens.some((token) => token.toLowerCase() === part.toLowerCase());
      if (match) {
        return createElement("mark", { key: index, className: "dealmaker-highlight" }, part);
      }
      return createElement("span", { key: index }, part);
    }),
  );
}

export function commentDraft(firmName: string): string {
  const firm = firmName ? `${firmName} firm` : "a WSG member firm";
  return `I am an attorney at ${firm}, I recently saw your listing for a deal and I would like some more information regarding this deal. <QUESTIONS>\n\nI look forward to your response.\n\nBest regards,`;
}
